var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.375,
    height: 57.151,
    viewBox: "0 0 57.375 57.151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M52.332,1H5.043A5.048,5.048,0,0,0,0,6.043V53.108a5.048,5.048,0,0,0,5.043,5.043h47.29a5.048,5.048,0,0,0,5.043-5.043V6.043A5.048,5.048,0,0,0,52.332,1ZM5.043,4.362h47.29a1.683,1.683,0,0,1,1.681,1.681v8.4H3.362v-8.4A1.683,1.683,0,0,1,5.043,4.362Zm47.29,50.427H5.043a1.683,1.683,0,0,1-1.681-1.681v-35.3H54.013v35.3A1.683,1.683,0,0,1,52.332,54.789Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M208.425,196.133a1.681,1.681,0,0,0-2.207.883l-10.085,23.533a1.681,1.681,0,0,0,3.09,1.324l10.085-23.533A1.681,1.681,0,0,0,208.425,196.133Z",
    transform: "translate(-174.033 -173.145)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M87.4,241.63a1.681,1.681,0,0,0-2.363-.262l-8.4,6.724a1.682,1.682,0,0,0,0,2.625l8.4,6.724a1.681,1.681,0,1,0,2.1-2.625L80.375,249.4l6.764-5.411A1.681,1.681,0,0,0,87.4,241.63Z",
    transform: "translate(-67.487 -213.105)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M342.135,248.091l-8.4-6.724a1.681,1.681,0,1,0-2.1,2.625l6.764,5.411-6.764,5.411a1.681,1.681,0,1,0,2.1,2.625l8.4-6.724A1.681,1.681,0,0,0,342.135,248.091Z",
    transform: "translate(-293.907 -213.104)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(6.688 7.575)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(13.688 7.575)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(19.688 7.575)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M332.681,64.362h10.085a1.681,1.681,0,0,0,0-3.362H332.681a1.681,1.681,0,0,0,0,3.362Z",
    transform: "translate(-293.908 -53.276)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebicon);
export default __webpack_public_path__ + "static/media/webicon.ce2a24c3e0264767975b36bfd22dd175.svg";
export { ForwardRef as ReactComponent };